var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3344_32646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#161515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#063C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.03613 13.854C3.12613 13.854 3.21613 13.86 3.30013 13.86C5.13013 13.86 6.84013 13.332 8.28013 12.426C8.86813 15.468 11.5441 17.76 14.7601 17.76C17.3881 17.76 19.6561 16.224 20.7181 13.998C20.8021 13.956 20.8801 13.908 20.9641 13.86C19.8061 17.712 16.2301 20.52 12.0001 20.52C7.77013 20.52 4.19413 17.712 3.03613 13.854Z",
    fill: "url(#paint0_radial_3344_32646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.03613 13.854C3.12613 13.854 3.21613 13.86 3.30013 13.86C5.13013 13.86 6.84013 13.332 8.28013 12.426C8.86813 15.468 11.5441 17.76 14.7601 17.76C17.3881 17.76 19.6561 16.224 20.7181 13.998C20.8021 13.956 20.8801 13.908 20.9641 13.86C19.8061 17.712 16.2301 20.52 12.0001 20.52C7.77013 20.52 4.19413 17.712 3.03613 13.854Z",
    fill: "#04171E",
    fillOpacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.07812 14.004C3.15013 14.004 3.22813 14.004 3.30013 14.004C5.14213 14.004 6.85812 13.47 8.31012 12.552C8.94612 15.528 11.5921 17.76 14.7601 17.76C17.3881 17.76 19.6561 16.224 20.7181 13.998C20.8021 13.956 20.8801 13.908 20.9641 13.86C19.8061 17.712 16.2301 20.52 12.0001 20.52C7.81812 20.52 4.28412 17.784 3.07812 14.004Z",
    fill: "url(#paint1_radial_3344_32646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.07812 14.004C3.15013 14.004 3.22813 14.004 3.30013 14.004C5.14213 14.004 6.85812 13.47 8.31012 12.552C8.94612 15.528 11.5921 17.76 14.7601 17.76C17.3881 17.76 19.6561 16.224 20.7181 13.998C20.8021 13.956 20.8801 13.908 20.9641 13.86C19.8061 17.712 16.2301 20.52 12.0001 20.52C7.81812 20.52 4.28412 17.784 3.07812 14.004Z",
    fill: "#04171E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4279 17.55C15.0959 18.654 13.3859 19.32 11.5199 19.32C8.03386 19.32 5.09386 16.998 4.15186 13.824C5.65786 13.686 7.06186 13.194 8.27986 12.426C8.86786 15.468 11.5439 17.76 14.7599 17.76C15.3359 17.76 15.8939 17.688 16.4279 17.55Z",
    fill: "url(#paint2_linear_3344_32646)",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6798 11.16C19.6798 15.402 16.2418 18.84 11.9998 18.84C7.75782 18.84 4.31982 15.402 4.31982 11.16C4.31982 6.91798 7.75782 3.47998 11.9998 3.47998C16.2418 3.47998 19.6798 6.91798 19.6798 11.16Z",
    fill: "url(#paint3_radial_3344_32646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1701 9.72007C19.1701 12.7021 16.7521 15.1201 13.7701 15.1201C10.7881 15.1201 8.37012 12.7021 8.37012 9.72007C8.37012 6.73807 10.7881 4.32007 13.7701 4.32007C16.7521 4.32007 19.1701 6.73807 19.1701 9.72007Z",
    fill: "url(#paint4_radial_3344_32646)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5039 4.32596C12.3839 4.31996 12.2639 4.31396 12.1379 4.31396C10.9919 4.31396 9.90587 4.60196 8.96387 5.11196C9.46787 4.99796 9.99587 4.94396 10.5359 4.94396C11.0879 4.94396 11.6219 5.00396 12.1319 5.11796L12.5039 4.32596Z",
    fill: "url(#paint5_linear_3344_32646)",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9482 5.35808C15.7742 6.35408 17.7962 9.04208 17.7962 12.2101C17.7962 13.5121 17.4542 14.7301 16.8542 15.7861C18.0842 14.5741 18.8402 12.8881 18.8402 11.0221C18.8402 7.74008 16.4882 5.01608 13.3802 4.43408L12.9482 5.35808Z",
    fill: "url(#paint6_linear_3344_32646)",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1041 17.6521C14.9161 18.4021 13.5121 18.8401 12.0001 18.8401C9.60606 18.8401 7.47006 17.7481 6.06006 16.0321C6.45006 16.1041 6.84606 16.1401 7.26006 16.1401C10.2301 16.1401 12.7381 14.1781 13.5721 11.4841C13.8481 11.5081 14.1241 11.5201 14.4001 11.5201C16.3201 11.5201 18.1021 10.9441 19.5841 9.9541C19.6441 10.3501 19.6801 10.7521 19.6801 11.1601C19.6801 11.4121 19.6681 11.6641 19.6441 11.9161C19.2121 14.2441 17.9161 16.2721 16.1041 17.6521Z",
    fill: "url(#paint7_linear_3344_32646)",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.03613 13.866C4.19413 17.718 7.77013 20.526 12.0001 20.526C17.1481 20.526 21.3301 16.368 21.3601 11.226C20.8441 11.22 20.3401 11.178 19.8541 11.094C18.7021 11.604 17.4241 11.886 16.0801 11.886C15.6121 11.886 15.1561 11.85 14.7121 11.784C13.8841 14.484 11.3701 16.446 8.40013 16.446C6.33013 16.446 4.48213 15.492 3.27013 13.998C3.19213 13.95 3.11413 13.908 3.03613 13.866Z",
    fill: "url(#paint8_linear_3344_32646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3601 11.2261C19.9861 12.0241 18.3841 12.4801 16.6801 12.4801C16.3561 12.4801 16.0321 12.4621 15.7201 12.4321C15.1261 15.4681 12.4501 17.7601 9.24013 17.7601C6.61213 17.7601 4.34413 16.2241 3.28213 13.9981C3.19813 13.9561 3.12013 13.9081 3.03613 13.8601C4.19413 17.7121 7.77013 20.5201 12.0001 20.5201C17.1481 20.5201 21.3241 16.3681 21.3601 11.2261Z",
    fill: "url(#paint9_radial_3344_32646)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7058 11.796C14.7178 11.784 14.7358 11.778 14.7478 11.79C15.0598 12.036 15.3958 12.258 15.7618 12.444C15.7798 12.45 15.7858 12.474 15.7738 12.486C15.7618 12.498 15.7498 12.51 15.7318 12.498C15.3658 12.312 15.0238 12.09 14.7118 11.838C14.6998 11.832 14.6938 11.808 14.7058 11.796Z",
    fill: "url(#paint10_linear_3344_32646)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3344_32646",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9616 18.5461) rotate(179.948) scale(67.9614 197.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1042,
    stopColor: "#24537E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5203,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAFFF4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3344_32646",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9616 18.546) rotate(179.948) scale(67.9614 197.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1042,
    stopColor: "#24537E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5203,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAFFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3344_32646",
    x1: 11.4154,
    y1: 21.5333,
    x2: 8.32757,
    y2: 5.47203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04171E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04171E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3344_32646",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.3699 17.1563) rotate(-57.5402) scale(13.5289 196.042)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1042,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5203,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3344_32646",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1383 4.31904) rotate(144.267) scale(13.3046 13.2102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9063,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3344_32646",
    x1: 15.043,
    y1: 3.14899,
    x2: 7.12297,
    y2: 6.59899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7324,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3344_32646",
    x1: 17.6032,
    y1: 9.02559,
    x2: 9.68317,
    y2: 12.4756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7324,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3344_32646",
    x1: 35.9272,
    y1: -3.84973,
    x2: 3.53491,
    y2: 23.1374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04171E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04171E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3344_32646",
    x1: 18.3817,
    y1: 13.6405,
    x2: 6.23163,
    y2: 17.9305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E6585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04171E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3344_32646",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.49737 19.5061) rotate(-38.5632) scale(11.0779 172.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1042,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5203,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3344_32646",
    x1: 15.7665,
    y1: 12.4812,
    x2: 14.2475,
    y2: 11.5422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CF2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3344_32646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwth);
export default __webpack_public_path__ + "static/media/swth.cd75446aa74ff23f492191f64b8289e9.svg";
export { ForwardRef as ReactComponent };